import { IBoardRankingGroup } from '../../../dtos/IBoardSnapshot';
import { categoryLabel, modalityLabel } from '../../../utils/tournament/labels';

export { categoryLabel, modalityLabel };

export const groupKey = (group: IBoardRankingGroup): string =>
  `${group.tournament_modality_id}:${group.category}`;

export const groupTitle = (group: IBoardRankingGroup): string =>
  `${modalityLabel(group.modality)} · ${categoryLabel(group.category)}`;

export const formatTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

export const formatSeconds = (seconds: number | null): string => {
  if (seconds === null || seconds === undefined) return '—';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}min ${String(s).padStart(2, '0')}s` : `${s}s`;
};
